import React from 'react';
import '../styles/Heading.scss';

const Heading = () => {
  return (
    <div className='headingDiv'> <h1 className='headingS'>Top House Cleaning Services in Delhi NCR</h1></div>
  )
}

export default Heading